import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { CodeWordCase } from '@/types/patient-api';

/**
 * Master data — Allergen Severities dropdown options for the Add Allergy
 * form (PROD-827 chart write surfaces).
 *
 * Wire (Flutter `common_data_source_impl.dart:1010`):
 *
 *   GET /api/Master/AllergenSeverity
 *       → CodeWordCase[]
 *
 * Curl-verified by Andrew 2026-05-19. Static catalog (Minor / Moderate /
 * Severe / Critical, system "HL7128"). Long staleTime is safe.
 *
 * UI label: "Severity". Wire field on PatientAllergy: `criticality`
 * (locked in Slice 1 — "Severity" UI label binds to `criticality.display`,
 * NOT a separate field).
 */

export function useAllergenSeverities(enabled = true) {
  return useQuery({
    queryKey: ['master-allergen-severities'],
    queryFn: ({ signal }) =>
      get<CodeWordCase[]>('/api/Master/AllergenSeverity', { signal }),
    enabled,
    staleTime: 24 * 60 * 60 * 1000,
  });
}
